export default {
  className: 'property',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '标题不可为空'
      ]
    },
    {
      name: 'phone',
      validators: [
        (val) => val ? null : '联系电话不可为空'
      ]
    },
    {
      name: 'quarters',
      render: (record) => {
        return `${record.quarters.name}`
      },
      validators: [
        (val) => val ? null : '关联小区不可为空'
      ]
    },
    {
      name: 'address',
      note: '地址',
      validators: [
        (val) => val ? null : '联系地址不可为空'
      ]
    }
  ]
}
